import {formDataInstance, gatewayInstance} from "../../axiosInstance";
import {SERVICE_ENDPOINT} from "../../const";

export const addDeductionMaster = async (data) => {
  try {
    console.log("add Deduction Master", data);
    return await gatewayInstance.post("/financeservice/deductionMaster", data);
  } catch (e) {
    console.error(e);
  }
};
export const deductionMasterById = async (id) => {
  try {
    console.log("response deductionMasterById", id);
    const response = await gatewayInstance.get(
      `/financeservice/deductionMaster/${id}`,
    );
    console.log("deductionMasterById", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateDeductionMaster = async (data) => {
  try {
    console.log("updateDeductionMaster", data);
    return await gatewayInstance.put("/financeservice/deductionMaster", data);
  } catch (e) {
    console.error(e);
  }
};

export const searchDeductionMaster = async (data) => {
  try {
    console.log("searchDeductItems", data);
    const response = await gatewayInstance.post(
      "/financeservice/deductionMaster/search",
      data,
    );
    console.log("item serch res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const reportSearchDeductionMaster = async (data) => {
  try {
    console.log("reportSearchDeductionMaster", data);
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.REPORT}/deduction-report/reportSearch`,
      data,
    );
    console.log("report Search res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const reportSearchGenerateDeductionMaster = async (data) => {
  try {
    console.log("reportSearchDeductionMaster", data);
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.REPORT}/deduction-report/downloadDeductionExcel`,
        data,
        {
          responseType: "blob",
        }
    );
    console.log("report Search res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const findByDedJobIdAndDedVehicle = async (jobId, vehicle) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/fuel/byjob/${jobId}/byvehicle/${vehicle}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const checkApprovePartyAvailability = async (type) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/checkApprovers/${type}`,
    );
    console.log("deductionMasterById", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const uploadDeductionBulkData = async (data) => {
  await formDataInstance.post(
      `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/excelUpload`,
      data
  );
};

export const searchBulkDeduction = async (data) => {
  try {
    console.log("bulk deductionMaster", data);
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/searchDeductionExcelHeader`,
        data,
    );
    console.log("BulkDeductionMaster res", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const DeductionExcelLinesById = async (data) => {
  try {

    console.log("req DeductionExcelLinesById", data);
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/searchJDeductionExcelLines?deductionHeaderId=${parseInt(data, 10)}`
    );
    console.log("response DeductionExcelLinesById", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const existsByDetStatusAndDetActiveAndDetDedId = async (id) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.FINANCE}/deductionMaster/deduction-app-status/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const dedAppLevelDropdown = async (company) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval/app-level-dropdown/${company}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
